import { Reveal } from "@/components/site/Reveal";
import { fileUrl } from "@/lib/api";

export default function About({ content }) {
  const photo = fileUrl(content?.doctor_photo);
  return (
    <section id="about" className="relative py-28 lg:py-40 max-w-7xl mx-auto px-6 lg:px-10" data-testid="about">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div className="relative">
              <div className="arch overflow-hidden aspect-[3/4] shadow-[0_30px_80px_rgba(47,51,43,0.16)]">
                {photo ? (
                  <img src={photo} alt={content?.doctor_name} className="w-full h-full object-cover" data-testid="about-doctor-photo" />
                ) : (
                  <div className="w-full h-full bg-beige" />
                )}
              </div>
              <div className="absolute -bottom-6 right-6 px-6 py-4 rounded-2xl bg-cream shadow-xl border border-blush/30">
                <p className="font-serif text-2xl text-olive-deep leading-none">MD, OBGYN</p>
                <p className="font-sans text-[10px] tracking-widest uppercase text-olive-sage mt-1">AIIMS, New Delhi</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="font-sans text-xs tracking-[0.3em] uppercase text-blush-dusty mb-4">Meet your doctor</p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-olive-deep leading-[1.02]">
              {content?.doctor_name || "Dr. Shivani Jain"}
            </h2>
            <p className="font-sans text-sm tracking-[0.15em] uppercase text-olive-sage mt-3">
              {content?.credentials || "MBBS, DNB, MD (AIIMS, N. Delhi)"}
            </p>
            <p className="font-sans text-sm tracking-[0.15em] uppercase text-blush-dusty mt-1.5">
              Certified Fertility Specialist · Garbhagudi, Bengaluru
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="font-sans text-base sm:text-lg text-olive-sage mt-8 leading-relaxed whitespace-pre-line" data-testid="about-bio">
              {content?.bio}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-8">
              {[["AIIMS", "Trained"], ["10+ yrs", "Experience"], ["IUI / IVF", "Fertility care"]].map(([a, b]) => (
                <div key={b} className="border-l-2 border-blush-dusty pl-4">
                  <p className="font-serif text-3xl text-olive-deep">{a}</p>
                  <p className="font-sans text-xs tracking-widest uppercase text-olive-sage mt-1">{b}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
